export interface RouteBounds {
  north: number
  south: number
  east: number
  west: number
}

export function isValidRouteBounds(bounds: RouteBounds | null | undefined): bounds is RouteBounds {
  return Boolean(
    bounds &&
      Number.isFinite(bounds.north) &&
      Number.isFinite(bounds.south) &&
      Number.isFinite(bounds.east) &&
      Number.isFinite(bounds.west) &&
      bounds.north >= bounds.south &&
      bounds.east >= bounds.west &&
      Math.abs(bounds.north) <= 90 &&
      Math.abs(bounds.south) <= 90 &&
      Math.abs(bounds.east) <= 180 &&
      Math.abs(bounds.west) <= 180,
  )
}

export function shouldAutoFocusWatchedCamera({
  hasViewerOverride,
  hasRouteBounds,
}: {
  hasViewerOverride: boolean
  hasRouteBounds: boolean
}): boolean {
  return hasViewerOverride || !hasRouteBounds
}
